import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/Error.js";
import { Stack } from "@mui/material";
export const FormControlPresets = (tokens) => {
    var _a;
    const error = tokens.component.formField.error;
    const iconSizes = tokens.semantic.iconSize;
    // find the same token in `iconSizes`
    const iconSizeKey = (_a = Object.entries(iconSizes).find(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_, value]) => value.value === error.icon.width.value)) === null || _a === void 0 ? void 0 : _a[0];
    return {
        ErrorMessageWithIcon: ({ children }) => (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: error.gap.value, sx: Object.assign({}, (iconSizeKey && {
                "--atlas-icon-size": iconSizeKey,
            })) }, { children: [_jsx(ErrorIcon, {}), children] }))),
    };
};
//# sourceMappingURL=formControl.js.map